import {
  faComment,
  faEnvelope,
  faEnvelopeOpen
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
// import { usePatchReadMutation } from 'utils/rest/feedback/readFeedback';

const ActionsFeedback = ({ data }) => {
  // const { mutate: markAsRead } = usePatchReadMutation();

  // const handleRead = () => {
  //   const body = {
  //     readYN: 1
  //   };
  //   markAsRead({ input: body, id: data.original.id });
  // };
  return (
    <div className="d-flex justify-content-center gap-3">
      {data.original.readYN ? (
        <FontAwesomeIcon icon={faEnvelopeOpen} />
      ) : (
        <FontAwesomeIcon
          icon={faEnvelope}
          // onClick={handleRead}
        />
      )}
      <FontAwesomeIcon icon={faComment} className="hover cursor-pointer" />
    </div>
  );
};

export default ActionsFeedback;
